import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from '/home/node/asta/apps/oss/src/layout/DocsLayout'
import __nextra_themeConfig from '/home/node/asta/apps/oss/theme.config.tsx'


/*@jsxRuntime automatic @jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
export const __toc = [{
  depth: 2,
  value: "Example Use",
  id: "example-use"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    h2: "h2",
    code: "code",
    pre: "pre",
    span: "span"
  }, _provideComponents(), props.components);
  return <><_components.h1>{"Using the API: DevOps Automation"}</_components.h1>{"\n"}<_components.p>{"You can use the API to integrate ASTA into your DevOps processes. This includes running tests from your DevOps pipeline to automatically validate builds before and/or after deployment."}</_components.p>{"\n"}<_components.h2 id="example-use">{"Example Use"}</_components.h2>{"\n"}<_components.p>{"The following example demonstrates how to run ASTA tests via API calls using a Bash script. This can be adapted for use in CI/CD pipelines or local development environments. The current files used in this example are available in the public asta-actions GitHub repository (see \"scripts/simple-runner\" folder)."}</_components.p>{"\n"}<_components.p>{"Set up the required environment variables in a "}<_components.code>{".env"}</_components.code>{" file based on the provided "}<_components.code>{".env-template"}</_components.code>{"."}</_components.p>{"\n"}<_components.pre data-language="code" data-theme="default"><_components.code data-language="code" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"# Personal and project settings for running ASTA tests"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"# This file is intended to be sourced by run-asta-tests-main"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }} /></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"# ASTA_API_URL=https://sqabot.ai/api/v2\t\t# Optional/default"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"ASTA_USER_PAT=your-personal-access-token-here"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"ASTA_VARIANT_ID=your-app-variant-id-here"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"Then, run the "}<_components.code>{"run-asta-tests-main"}</_components.code>{" script with the desired parameters."}</_components.p>{"\n"}<_components.pre data-language="bash" data-theme="default"><_components.code data-language="bash" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#!/usr/bin/env bash"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# ----------------------------------------------------------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Script Name: run-asta-tests-main.sh"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Description: Starts one or more ASTA test runs using the run-asta-tests.sh script."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Usage: ./run-asta-tests-main.sh"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Dependencies:"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#   - run-asta-tests.sh (must be in the same directory)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#   - .env file (optional) containing:"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#   - ASTA_USER_PAT - An environment variable containing the ASTA user personal access token."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#   - ASTA_VARIANT_ID - An environment variable containing the ASTA app variant ID to run tests against."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#   - ASTA_API_URL - (Optional) An environment variable containing the ASTA API URL. See called script for default."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#\t- bash"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Author: Business Performance Systems"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Copyright: None. Free to use and share."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# ----------------------------------------------------------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"set"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-euo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"pipefail"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Test error thresholds (-1 = ignore)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"ERROR_THRESHOLDS"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"0,0,-1,-1,-1\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# critical, serious, moderate, minor, total"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Script directory, which may be different from the current working directory"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"SCRIPT_DIR"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"cd"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"dirname"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"${BASH_SOURCE[0]}\")\" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{"&&"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"pwd"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{")\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Set PAT and variant ID from .env file if present"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Otherwise, they must be set in the environment before running this script"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [[ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-f"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${SCRIPT_DIR}/.env\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ]]; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"export"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"grep"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-v"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" '^#' \"${SCRIPT_DIR}/.env\" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"sed"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" 's/[[:space:]]*#.*$//' "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"xargs"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Calling run-asta-tests.sh to start ASTA test runs...\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"${SCRIPT_DIR}/run-asta-tests.sh "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"your%20template%20name\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" your_wait_time_in_minutes "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${ERROR_THRESHOLDS}\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Add additional test runs as needed"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"This script uses the following script to call the ASTA API."}</_components.p>{"\n"}<_components.pre data-language="bash" data-theme="default"><_components.code data-language="bash" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#!/usr/bin/env bash"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# ----------------------------------------------------------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Description: Starts an ASTA test run via API call. For use in a deployment pipeline."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Usage: ./run-asta-tests-jq.sh <RUN_TEMPLATE_ID_OR_NAME> [WAIT_FOR_COMPLETION_MINUTES] [ERROR_THRESHOLDS_STRING]"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Dependencies:"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#   - bash, curl, jq (auto-installed if missing)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#   - The following environment variables must be set:"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#\t- ASTA_USER_PAT - The ASTA user personal access token"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#\t- ASTA_VARIANT_ID - The ASTA app variant ID to run tests against."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"#\t- ASTA_API_URL - (Optional) The ASTA API URL. See below for default."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Note: The specified ASTA_USER must have access to the specified variant and run template."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Author: Business Performance Systems"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Copyright: None. Free to use and share."}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# ----------------------------------------------------------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"set"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-euo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"pipefail"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Inputs"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"RUN_TEMPLATE_ID_OR_NAME"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${1"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"}\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"WAIT_FOR_COMPLETION_MINUTES"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${2"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"10}\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"   "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# 0 = do not wait"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"ERROR_THRESHOLDS_STRING"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${3"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"0,0,-1,-1,-1\"}\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# critical, serious, moderate, minor, total; -1 = ignore"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Parse error thresholds into associative array"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"IFS"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"','"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"read"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-r"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-a"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"etarray"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<<<"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$ERROR_THRESHOLDS_STRING\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"declare"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-A"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"ERROR_THRESHOLDS="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t[critical]="}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"\"${etarray[0]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"0}\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t[serious]="}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"\"${etarray[1]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"0}\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t[moderate]="}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"\"${etarray[2]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"-1}\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t[minor]="}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"\"${etarray[3]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"-1}\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t[total]="}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"\"${etarray[4]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"-1}\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# -----------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Logging helpers"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{"()"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"       { "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$@\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_info"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{"()"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"[INFO] $@\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_debug"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{"()"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"[DEBUG] $@\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"error_exit"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{"()"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"[ERROR] $@\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">&2"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# -----------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Validate inputs (args and env vars)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [[ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-z"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$RUN_TEMPLATE_ID_OR_NAME\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ]]; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_info"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Missing required arguments.\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"error_exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Usage: $0 <RUN_TEMPLATE_ID_OR_NAME> [WAIT_FOR_COMPLETION_MINUTES] [ERROR_THRESHOLDS_STRING]\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [[ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-z"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${ASTA_USER_PAT"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"}\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"||"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-z"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${ASTA_VARIANT_ID"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"}\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ]]; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"error_exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Missing required environment variables ASTA_USER_PAT or ASTA_VARIANT_ID.\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# -----------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Ensure jq is installed"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"command"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-v"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"jq"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"/dev/null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"2>&1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_info"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"jq not found. Attempting to install...\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"command"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-v"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"apt-get"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"/dev/null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"2>&1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"sudo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"apt-get"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"update"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-y"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{"&&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"sudo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"apt-get"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"install"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-y"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"jq"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"elif"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"command"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-v"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"yum"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"/dev/null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"2>&1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"sudo"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"yum"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"install"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-y"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"jq"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"elif"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"command"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-v"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"apk"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{">"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"/dev/null"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"2>&1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"apk"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"add"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"--no-cache"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"jq"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"error_exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"jq is required but no supported package manager found.\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# -----------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Config"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"ASTA_API_URL"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"https://sqabot.ai/api/v2\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"AUTH_HEADER"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Authorization: Bearer $ASTA_USER_PAT\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"CONTENT_HEADER"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Content-Type: application/json\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# -----------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Start ASTA run"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_info"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Starting ASTA test run on variant $ASTA_VARIANT_ID with template $RUN_TEMPLATE_ID_OR_NAME...\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"start_response"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"curl"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-s"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-X"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"POST"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \\"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-H"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$AUTH_HEADER\" \\"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-H"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$CONTENT_HEADER\" \\"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"  \"$ASTA_API_URL/start/template/$ASTA_VARIANT_ID/$RUN_TEMPLATE_ID_OR_NAME\" \\"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-d"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" '{}')"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"RUN_ID"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$start_response\" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"jq"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-r"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" '.runId')"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"RUN_NUMBER"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$start_response\" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"jq"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-r"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" '.runNumber')"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [[ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-z"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$RUN_ID\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"||"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$RUN_ID\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"null\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ]]; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"error_exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Failed to start ASTA run. Response: $start_response\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_info"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Test run number $RUN_NUMBER started (runId=$RUN_ID)\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# -----------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Wait for completion"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [[ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$WAIT_FOR_COMPLETION_MINUTES\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-gt"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ]]; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_debug"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Waiting for test completion...\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  POLL_ATTEMPTS"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"5"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  POLL_INTERVAL"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"$(( WAIT_FOR_COMPLETION_MINUTES "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"*"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"60"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"/"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{" POLL_ATTEMPTS ))"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"for"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ((i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"<="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"POLL_ATTEMPTS; i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"++"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{")); "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"do"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"sleep"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$POLL_INTERVAL\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    status_response"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"curl"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-s"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-H"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$AUTH_HEADER\" \\"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"      \"$ASTA_API_URL/run/$RUN_ID/status/$ASTA_VARIANT_ID\")"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    status"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$status_response\" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"jq"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-r"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" '.status')"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_debug"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Status check $i/$POLL_ATTEMPTS: $status\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [[ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$status\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"stopped\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ]]; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"break"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" [[ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$i\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-eq"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"$POLL_ATTEMPTS\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ]]; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"then"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"error_exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Max wait time exceeded. Test still running.\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"done"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_info"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"WAIT_FOR_COMPLETION_MINUTES=0, exiting without waiting.\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"fi"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# -----------------------------"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Process results"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Fetch final status with error counts"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"status_response"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"curl"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-s"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-H"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$AUTH_HEADER\" \\"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"  \"$ASTA_API_URL/run/$RUN_ID/status/$ASTA_VARIANT_ID?includeErrorCount=true\")"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# log_debug \"Final status response: $status_response\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Extract error counts"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"declare"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-A"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"error_counts"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"for"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" level "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"in"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" critical serious moderate minor total; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"do"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\terror_counts[$level]"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"$("}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"echo"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \"$status_response\" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"|"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"jq"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string)"
  }}>{"-r"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{" \".errors.$level // 0\")"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"done"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_debug"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Error counts: ${error_counts[*]} (critical, serious, moderate, minor, total)\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log_debug"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Error thresholds: ${ERROR_THRESHOLDS[*]} (critical, serious, moderate, minor, total)\""}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"# Compare against thresholds"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"for"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" level "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"in"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" critical serious moderate minor total; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"do"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t[[ "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${ERROR_THRESHOLDS[$level]}\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-ge"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"&&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${error_counts[$level]}\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-gt"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"${ERROR_THRESHOLDS[$level]}\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ]] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{"&&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" \\"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"\t\t"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"error_exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Test run FAILED: $level errors (${error_counts[$level]}) exceed threshold (${ERROR_THRESHOLDS[$level]}).\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"done"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"log"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"Test run PASSED: no error thresholds exceeded.\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"exit"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"0"}</_components.span></_components.span></_components.code></_components.pre></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"src/pages/docs/UserDocs/AdvancedTopics/API.md","route":"/docs/UserDocs/AdvancedTopics/API","pageMap":[{"kind":"Meta","data":{"docs":{"title":"ASTA Docs","type":"page"}}},{"kind":"Folder","name":"docs","route":"/docs","children":[{"kind":"Folder","name":"UserDocs","route":"/docs/UserDocs","children":[{"kind":"Folder","name":"AdvancedTopics","route":"/docs/UserDocs/AdvancedTopics","children":[{"kind":"MdxPage","name":"API","route":"/docs/UserDocs/AdvancedTopics/API"},{"kind":"MdxPage","name":"ClassificationSystem","route":"/docs/UserDocs/AdvancedTopics/ClassificationSystem"},{"kind":"MdxPage","name":"Data","route":"/docs/UserDocs/AdvancedTopics/Data"},{"kind":"MdxPage","name":"Flows","route":"/docs/UserDocs/AdvancedTopics/Flows"},{"kind":"MdxPage","name":"FormSpecifications","route":"/docs/UserDocs/AdvancedTopics/FormSpecifications"},{"kind":"MdxPage","name":"ImpactLevels","route":"/docs/UserDocs/AdvancedTopics/ImpactLevels"},{"kind":"MdxPage","name":"Introduction","route":"/docs/UserDocs/AdvancedTopics/Introduction"},{"kind":"MdxPage","name":"LanguageReference","route":"/docs/UserDocs/AdvancedTopics/LanguageReference"},{"kind":"MdxPage","name":"Rules","route":"/docs/UserDocs/AdvancedTopics/Rules"},{"kind":"MdxPage","name":"RunTemplates","route":"/docs/UserDocs/AdvancedTopics/RunTemplates"},{"kind":"MdxPage","name":"Spelling","route":"/docs/UserDocs/AdvancedTopics/Spelling"},{"kind":"MdxPage","name":"Tags","route":"/docs/UserDocs/AdvancedTopics/Tags"},{"kind":"MdxPage","name":"Views","route":"/docs/UserDocs/AdvancedTopics/Views"},{"kind":"MdxPage","name":"Workspaces","route":"/docs/UserDocs/AdvancedTopics/Workspaces"},{"kind":"Meta","data":{"Introduction":"Introduction","ImpactLevels":"Impact Levels","Data":"Data","Flows":"Flows","Rules":"Rules","LanguageReference":"Language Reference","FormSpecifications":"Form Specifications","Views":"Views","RunTemplates":"Run Templates","Tags":"Tags","Workspaces":"Workspaces","ClassificationSystem":"Classification System","Spelling":"Spelling","API":"API"}}]},{"kind":"MdxPage","name":"Benefits","route":"/docs/UserDocs/Benefits"},{"kind":"MdxPage","name":"HowItWorks","route":"/docs/UserDocs/HowItWorks"},{"kind":"MdxPage","name":"QuickStart","route":"/docs/UserDocs/QuickStart"},{"kind":"Meta","data":{"QuickStart":"Quick Start","HowItWorks":"How It Works","AdvancedTopics":"Advanced Topics","Benefits":"Benefits"}}]},{"kind":"Meta","data":{"index":"Introduction","UserDocs":"User Docs"}},{"kind":"MdxPage","name":"index","route":"/docs"}]}],"flexsearch":{"codeblocks":true},"title":"Using the API: DevOps Automation",headings:__toc},
  pageNextRoute: "/docs/UserDocs/AdvancedTopics/API",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)